/**
 * FTE-labels — pure opmaakhelpers voor het FTE-overzicht. Geen React, geen JSX.
 *
 * Stond eerder als losse consts bovenin FteTab.jsx. Hier weggehaald omdat de diagnostiek
 * (client/test/diag/fte-splitsing-wk32.mjs) de LABELS moet kunnen narekenen zoals ze op het
 * scherm komen. Node kan geen .jsx importeren, dus de enige alternatieven waren: het
 * diagnosescript een eigen kopie geven, of de helpers hierheen halen. Een kopie zou precies
 * de fout herhalen die dit bestand moet voorkomen — een diagnose die iets anders meet dan
 * wat er draait — dus staan ze nu op één plek en importeren FteTab én het script ze hier.
 */

// verlof/ziekte/anders -> verlof/ziek/afwezig (zelfde mapping als TeamRooster).
export const afwLabel = (t) => (t === 'ziekte' ? 'ziek' : t === 'anders' ? 'afwezig' : 'verlof');

// Uren compact: hele getallen zonder decimaal (448u), gebroken met één (95.5u).
export const uur = (n) => `${Number.isInteger(n) ? n : n.toFixed(1)}u`;

/**
 * Eén of meer afwezigheidstypen als label: "ziek", of "ziek en verlof" als er in dezelfde
 * week meer dan één soort speelde. Alleen `type` tonen is een onjuiste uitspraak — dat veld
 * draagt het type van de EERSTE afwezige werkdag (fte.js) en gold daarmee ook voor de dagen
 * erna. Valt terug op `type` zolang een aanroeper nog geen `typen` meegeeft.
 */
export function typenLabel(a) {
  const lijst = (Array.isArray(a?.typen) && a.typen.length ? a.typen : [a?.type]).map(afwLabel);
  return lijst.length === 1 ? lijst[0] : `${lijst.slice(0, -1).join(', ')} en ${lijst[lijst.length - 1]}`;
}

/**
 * "Alper (verlof, 36u) · Bayram (verlof, 36u)" — namen alfabetisch, zelfde afwLabel als de
 * tabel. De uren komen per persoon uit fte.js.
 */
export const afwSamenvatting = (afwezigen) => Object.entries(afwezigen || {})
  .sort((a, b) => a[0].localeCompare(b[0], 'nl'))
  .map(([naam, a]) => `${naam} (${typenLabel(a)}, ${uur(a.uren)})`)
  .join(' · ');

/**
 * Eén van de twee emmers uit fte.js als afwSamenvatting-invoer: `uren` en `typen` wijzen naar
 * de velden van díe emmer, zodat er maar één manier blijft om namen en uren op te maken.
 * Mensen zonder uren in deze emmer vallen weg — iemand kan in beide lijstjes staan of in één.
 */
export const emmer = (afwezigen, urenVeld, typenVeld) => Object.fromEntries(
  Object.entries(afwezigen || {})
    .filter(([, a]) => (a[urenVeld] ?? 0) > 0)
    .map(([naam, a]) => [naam, { ...a, uren: a[urenVeld], typen: a[typenVeld] }]),
);
